import React from "react";

import { Route, Switch, Redirect } from "react-router-dom";
import ComingSoon from "./report/ComingSoon";
import Revenue from "./report/Revenue";
import Dashboard from "./report/Dashboard";

const Report = (props) => {
  return (
    <Switch>
      <Redirect exact from="/report" to="/report/dashboard" />
      <Route path="/report/dashboard" component={Dashboard} />
      <Route path="/report/revenue" component={Revenue} />
      <Route path="/report/introduce" component={ComingSoon} />
    </Switch>
  );
};

export default Report;
